'use client';

import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["defaultSelected", "onOpenChange", "open", "keepOpenOnSelect", "loading", "className", "size", "disabled", "placeholder", "options", "removePortal", "dropdownContentClassName"],
  _excluded2 = ["loading", "options"];
import React, { useState } from 'react';
import { useTranslation } from '@crehana/i18n';
import locales from "../../i18n";
import { PrimitiveDropdown, PrimitiveDropdownClientSearch, PrimitiveDropdownContent, PrimitiveDropdownEmpty, PrimitiveDropdownList, PrimitiveDropdownLoading, PrimitiveDropdownTrigger, PrimitiveDropdownValueButton } from "../../primitive-dropdown/primitive-dropdown";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function GenericDropdown(_ref) {
  var _otherProps$selected2, _otherProps$customTri2;
  var _ref$defaultSelected = _ref.defaultSelected,
    defaultSelected = _ref$defaultSelected === void 0 ? [] : _ref$defaultSelected,
    controlledOnOpenChange = _ref.onOpenChange,
    controlledOpen = _ref.open,
    keepOpenOnSelect = _ref.keepOpenOnSelect,
    loading = _ref.loading,
    className = _ref.className,
    size = _ref.size,
    disabled = _ref.disabled,
    placeholder = _ref.placeholder,
    options = _ref.options,
    removePortal = _ref.removePortal,
    dropdownContentClassName = _ref.dropdownContentClassName,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    uncontrolledOpen = _useState2[0],
    setUncontrolledOpen = _useState2[1];
  var onOpenChange = controlledOnOpenChange !== null && controlledOnOpenChange !== void 0 ? controlledOnOpenChange : setUncontrolledOpen;
  var _useState3 = useState(Array.isArray(defaultSelected) ? defaultSelected : [defaultSelected]),
    _useState4 = _slicedToArray(_useState3, 2),
    uncontrolledValues = _useState4[0],
    setUncontrolledValues = _useState4[1];
  var open = controlledOpen !== null && controlledOpen !== void 0 ? controlledOpen : uncontrolledOpen;
  var handleOpenChange = function handleOpenChange(open) {
    if (keepOpenOnSelect) {
      setUncontrolledOpen(open);
    } else {
      onOpenChange(open);
    }
  };
  if (!otherProps.multiselect) {
    var _otherProps$selected, _otherProps$customTri, _options$find;
    var selectedValue = (_otherProps$selected = otherProps.selected) !== null && _otherProps$selected !== void 0 ? _otherProps$selected : uncontrolledValues[0];
    var allowDeselect = otherProps.allowDeselect,
      controlledOnSelected = otherProps.onSelect;
    return /*#__PURE__*/_jsxs(PrimitiveDropdown, {
      open: open,
      onOpenChange: handleOpenChange,
      children: [/*#__PURE__*/_jsx(PrimitiveDropdownTrigger, {
        asChild: true,
        children: (_otherProps$customTri = otherProps.customTriggerButton) !== null && _otherProps$customTri !== void 0 ? _otherProps$customTri : /*#__PURE__*/_jsx(PrimitiveDropdownValueButton, {
          className: className,
          size: size,
          disabled: disabled,
          open: open,
          placeholder: placeholder,
          value: (_options$find = options.find(function (option) {
            return option.value === selectedValue;
          })) === null || _options$find === void 0 ? void 0 : _options$find.label
        })
      }), /*#__PURE__*/_jsxs(PrimitiveDropdownContent, {
        removePadding: true,
        removePortal: removePortal,
        className: dropdownContentClassName,
        children: [!otherProps.hideSearch && /*#__PURE__*/_jsx(SearchComponents, _objectSpread({
          options: options
        }, otherProps)), loading ? /*#__PURE__*/_jsx(PrimitiveDropdownLoading, {
          loading: loading
        }) : /*#__PURE__*/_jsx(PrimitiveDropdownList, {
          children: options.map(function (_ref2) {
            var Element = _ref2.element,
              value = _ref2.value;
            return /*#__PURE__*/_jsx(Element, {
              disabled: disabled,
              selected: selectedValue === value,
              value: value,
              onSelect: function onSelect() {
                if (!keepOpenOnSelect) handleOpenChange(false);
                var valueToPropagate = allowDeselect && selectedValue === value ? undefined : value;
                if (controlledOnSelected) {
                  if (allowDeselect) controlledOnSelected(valueToPropagate);
                  if (!allowDeselect && valueToPropagate) {
                    controlledOnSelected(valueToPropagate);
                  }
                }
                setUncontrolledValues(valueToPropagate ? [valueToPropagate] : []);
              }
            }, value);
          })
        })]
      })]
    });
  }
  var values = (_otherProps$selected2 = otherProps.selected) !== null && _otherProps$selected2 !== void 0 ? _otherProps$selected2 : uncontrolledValues;
  return /*#__PURE__*/_jsxs(PrimitiveDropdown, {
    open: open,
    onOpenChange: handleOpenChange,
    children: [/*#__PURE__*/_jsx(PrimitiveDropdownTrigger, {
      asChild: true,
      children: (_otherProps$customTri2 = otherProps.customTriggerButton) !== null && _otherProps$customTri2 !== void 0 ? _otherProps$customTri2 : /*#__PURE__*/_jsx(PrimitiveDropdownValueButton, {
        className: className,
        size: size,
        disabled: disabled,
        open: open,
        placeholder: placeholder,
        value: values.map(function (value) {
          var _options$find2;
          return (_options$find2 = options.find(function (option) {
            return option.value === value;
          })) === null || _options$find2 === void 0 ? void 0 : _options$find2.label;
        }).join(', ')
      })
    }), /*#__PURE__*/_jsxs(PrimitiveDropdownContent, {
      removePadding: true,
      removePortal: removePortal,
      children: [!otherProps.hideSearch && /*#__PURE__*/_jsx(SearchComponents, _objectSpread({
        options: options
      }, otherProps)), loading ? /*#__PURE__*/_jsx(PrimitiveDropdownLoading, {
        loading: loading
      }) : /*#__PURE__*/_jsx(PrimitiveDropdownList, {
        children: options.map(function (_ref3) {
          var Element = _ref3.element,
            value = _ref3.value;
          return /*#__PURE__*/_jsx(Element, {
            disabled: disabled,
            selected: values.includes(value),
            value: value,
            onSelect: function onSelect() {
              var valuesToPropagate = values.includes(value) ? values.filter(function (v) {
                return v !== value;
              }) : [].concat(_toConsumableArray(values), [value]);
              if (otherProps.onSelect) {
                otherProps.onSelect(valuesToPropagate);
              }
              setUncontrolledValues(valuesToPropagate);
            }
          }, value);
        })
      })]
    })]
  });
}
function SearchComponents(_ref4) {
  var _searchProps$searchPl, _searchProps$noFoundP, _searchProps$noFoundP2;
  var loading = _ref4.loading,
    options = _ref4.options,
    otherProps = _objectWithoutProperties(_ref4, _excluded2);
  if (otherProps.hideSearch) return null;
  var _useTranslation = useTranslation(),
    languageCode = _useTranslation.languageCode;
  var searchProps = otherProps.searchProps;
  var searchPlaceholder = (_searchProps$searchPl = searchProps === null || searchProps === void 0 ? void 0 : searchProps.searchPlaceholder) !== null && _searchProps$searchPl !== void 0 ? _searchProps$searchPl : locales[languageCode].DROPDOWN_SEARCH_PLACEHOLDER;
  var emptyViewTitle = (_searchProps$noFoundP = searchProps === null || searchProps === void 0 ? void 0 : searchProps.noFoundPlaceholderTitle) !== null && _searchProps$noFoundP !== void 0 ? _searchProps$noFoundP : locales[languageCode].DROPDOWN_EMPTY_TITLE;
  var emptyViewSubtitle = (_searchProps$noFoundP2 = searchProps === null || searchProps === void 0 ? void 0 : searchProps.noFoundPlaceholderSubtitle) !== null && _searchProps$noFoundP2 !== void 0 ? _searchProps$noFoundP2 : locales[languageCode].DROPDOWN_EMPTY_SUBTITLE;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PrimitiveDropdownClientSearch, {
      placeholder: searchPlaceholder
    }), !loading && /*#__PURE__*/_jsx(PrimitiveDropdownEmpty, {
      title: emptyViewTitle,
      subtitle: emptyViewSubtitle
    })]
  });
}